module.exports = __webpack_public_path__ + "img/16d001-09.1ae4db8b.jpg";